export default function SignIcon(props) {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <path id="sign_icon" data-name="Sign Icon" className={props.fill || ""} d="M38.75,5H10V1.25A1.254,1.254,0,0,0,8.75,0H6.25A1.254,1.254,0,0,0,5,1.25V5H1.25A1.254,1.254,0,0,0,0,6.25v2.5A1.254,1.254,0,0,0,1.25,10H5V38.75A1.254,1.254,0,0,0,6.25,40h2.5A1.254,1.254,0,0,0,10,38.75V10H38.75A1.254,1.254,0,0,0,40,8.75V6.25A1.254,1.254,0,0,0,38.75,5ZM12.5,30h25V12.5h-25Z"/>
    </svg>
  );
}
